module.exports = __webpack_public_path__ + "static/img/c2.49aac2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/success/c2.png
// module id = bdfa
// module chunks = 0